// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;500;600;700;900&family=Roboto:wght@300;400;500;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Fjalla+One&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button, .button {
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size:18px;
}

h1, .h1 {
  font-family: 'Raleway', sans-serif;
  font-weight: 700;
  font-size:48px;
}

h2, .h2 {
  font-family: 'Raleway', sans-serif;
  font-weight: 700;
  font-size:36px;
}

h3, .h3 {
  font-family: 'Raleway', sans-serif;
  font-weight: 700;
  font-size:30px;
}

h4, .h4 {
  font-family: 'Raleway', sans-serif;
  font-weight: 700;
  font-size:24px;
}

h5, .h5 {
  font-family: 'Raleway', sans-serif;
  font-weight: 700;
  font-size:20px;
}

h6, .h6 {
  font-family: 'Raleway', sans-serif;
  font-weight: 700;
  font-size:18px;
}

a, p, span, label, .body-1, .p {
  font-family: 'Roboto', sans-serif;
  font-size:16px;
  line-height: 150%;
}

b, .bold {
  font-family: 'Roboto', sans-serif;
  font-size:18px;
  font-weight: 700;
}

a, .link {
  background: none;
  border: none;
  color: #526AF2;
  cursor: pointer;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 18px;
  text-decoration: underline;
}

a:hover, .link:hover {
  color: #404FA1;
}

.body-2 {
  font-family: 'Roboto', sans-serif;
  font-size:16px;
}

.caption {
  font-family: 'Roboto', sans-serif;
  font-size:14px;
}

.subtitle-1 {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 130%;
  text-transform: uppercase;
}

.subtitle-2 {
  font-family: 'Raleway', sans-serif;
  font-size:16px;
}

label, .label {
  margin-top: 0;
  margin-bottom: 0.25rem;
  font-size: 0.95rem;
  text-align: left;
}

.hint {
  font-size: 0.75rem;
  margin-top: 0.25rem;
  margin-bottom: 0;
  text-align: left;
  color: #72757E;
}

.hint-error {
  color: #F24C27;
}

@media screen and (max-width: 480px) {
  button, .button {
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    font-size:18px;
  }

  h1, .h1 {
    font-family: 'Raleway', sans-serif;
    font-weight: 700;
    font-size:40px;
  }

  h2, .h2 {
    font-family: 'Raleway', sans-serif;
    font-weight: 700;
    font-size:36px;
  }

  h3, .h3 {
    font-family: 'Raleway', sans-serif;
    font-weight: 700;
    font-size:30px;
  }

  h4, .h4 {
    font-family: 'Raleway', sans-serif;
    font-weight: 700;
    font-size:20px;
  }

  h5, .h5 {
    font-family: 'Raleway', sans-serif;
    font-weight: 700;
    font-size:18px;
  }

  h6, .h6 {
    font-family: 'Raleway', sans-serif;
    font-weight: 700;
    font-size:16px;
  }

  a, p, span, label, .body-1, .p {
    font-family: 'Roboto', sans-serif;
    font-size:14px;
    line-height: 150%;
  }

  b, .bold {
    font-family: 'Roboto', sans-serif;
    font-size:16px;
    font-weight: 700;
  }

  a, .link {
    background: none;
    border: none;
    color: #526AF2;
    cursor: pointer;
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    font-size: 16px;
    text-decoration: none;
  }

  a:hover, .link:hover {
    color: #404FA1;
  }

  .body-2 {
    font-family: 'Roboto', sans-serif;
    font-size:14px;
  }

  .caption {
    font-family: 'Roboto', sans-serif;
    font-size:13px;
  }

  .subtitle-2 {
    font-family: 'Raleway', sans-serif;
    font-size:16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/library/style/typography.css"],"names":[],"mappings":"AAGA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,iCAAiC;IACjC,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,iCAAiC;IACjC,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,iCAAiC;IACjC,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,iCAAiC;IACjC,gBAAgB;IAChB,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iCAAiC;IACjC,cAAc;EAChB;;EAEA;IACE,iCAAiC;IACjC,cAAc;EAChB;;EAEA;IACE,kCAAkC;IAClC,cAAc;EAChB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;500;600;700;900&family=Roboto:wght@300;400;500;700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Fjalla+One&display=swap');\n\nbutton, .button {\n  font-family: 'Roboto', sans-serif;\n  font-weight: 500;\n  font-size:18px;\n}\n\nh1, .h1 {\n  font-family: 'Raleway', sans-serif;\n  font-weight: 700;\n  font-size:48px;\n}\n\nh2, .h2 {\n  font-family: 'Raleway', sans-serif;\n  font-weight: 700;\n  font-size:36px;\n}\n\nh3, .h3 {\n  font-family: 'Raleway', sans-serif;\n  font-weight: 700;\n  font-size:30px;\n}\n\nh4, .h4 {\n  font-family: 'Raleway', sans-serif;\n  font-weight: 700;\n  font-size:24px;\n}\n\nh5, .h5 {\n  font-family: 'Raleway', sans-serif;\n  font-weight: 700;\n  font-size:20px;\n}\n\nh6, .h6 {\n  font-family: 'Raleway', sans-serif;\n  font-weight: 700;\n  font-size:18px;\n}\n\na, p, span, label, .body-1, .p {\n  font-family: 'Roboto', sans-serif;\n  font-size:16px;\n  line-height: 150%;\n}\n\nb, .bold {\n  font-family: 'Roboto', sans-serif;\n  font-size:18px;\n  font-weight: 700;\n}\n\na, .link {\n  background: none;\n  border: none;\n  color: #526AF2;\n  cursor: pointer;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 400;\n  font-size: 18px;\n  text-decoration: underline;\n}\n\na:hover, .link:hover {\n  color: #404FA1;\n}\n\n.body-2 {\n  font-family: 'Roboto', sans-serif;\n  font-size:16px;\n}\n\n.caption {\n  font-family: 'Roboto', sans-serif;\n  font-size:14px;\n}\n\n.subtitle-1 {\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 130%;\n  text-transform: uppercase;\n}\n\n.subtitle-2 {\n  font-family: 'Raleway', sans-serif;\n  font-size:16px;\n}\n\nlabel, .label {\n  margin-top: 0;\n  margin-bottom: 0.25rem;\n  font-size: 0.95rem;\n  text-align: left;\n}\n\n.hint {\n  font-size: 0.75rem;\n  margin-top: 0.25rem;\n  margin-bottom: 0;\n  text-align: left;\n  color: #72757E;\n}\n\n.hint-error {\n  color: #F24C27;\n}\n\n@media screen and (max-width: 480px) {\n  button, .button {\n    font-family: 'Roboto', sans-serif;\n    font-weight: 500;\n    font-size:18px;\n  }\n\n  h1, .h1 {\n    font-family: 'Raleway', sans-serif;\n    font-weight: 700;\n    font-size:40px;\n  }\n\n  h2, .h2 {\n    font-family: 'Raleway', sans-serif;\n    font-weight: 700;\n    font-size:36px;\n  }\n\n  h3, .h3 {\n    font-family: 'Raleway', sans-serif;\n    font-weight: 700;\n    font-size:30px;\n  }\n\n  h4, .h4 {\n    font-family: 'Raleway', sans-serif;\n    font-weight: 700;\n    font-size:20px;\n  }\n\n  h5, .h5 {\n    font-family: 'Raleway', sans-serif;\n    font-weight: 700;\n    font-size:18px;\n  }\n\n  h6, .h6 {\n    font-family: 'Raleway', sans-serif;\n    font-weight: 700;\n    font-size:16px;\n  }\n\n  a, p, span, label, .body-1, .p {\n    font-family: 'Roboto', sans-serif;\n    font-size:14px;\n    line-height: 150%;\n  }\n\n  b, .bold {\n    font-family: 'Roboto', sans-serif;\n    font-size:16px;\n    font-weight: 700;\n  }\n\n  a, .link {\n    background: none;\n    border: none;\n    color: #526AF2;\n    cursor: pointer;\n    font-family: 'Roboto', sans-serif;\n    font-weight: 500;\n    font-size: 16px;\n    text-decoration: none;\n  }\n\n  a:hover, .link:hover {\n    color: #404FA1;\n  }\n\n  .body-2 {\n    font-family: 'Roboto', sans-serif;\n    font-size:14px;\n  }\n\n  .caption {\n    font-family: 'Roboto', sans-serif;\n    font-size:13px;\n  }\n\n  .subtitle-2 {\n    font-family: 'Raleway', sans-serif;\n    font-size:16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
